import translations from './i18n';

const ext = {
  th: {
    gm_btn_play: 'เข้าเล่น',
    gm_marquee: 'คาสิโนออนไลน์ สล็อตออนไลน์ ที่ให้คุณสนุกได้ทุกรูปแบบ',
    gm_subheading: 'คาสิโนออนไลน์เต็มรูปแบบ ตื่นตาตื่นใจไปกับทุกการเดิมพัน',
    gm_h1_casino: 'คาสิโนออนไลน์ บาคาร่า ไฮโล เสือมังกร เว็บตรง',
    gm_promotion: 'โปรโมชั่น',
    gm_pro_not_active: 'โปรโมชั่นยังไม่ได้เปิดใช้งาน',
    gm_get_promotion: 'รับโปรโมชั่น',
    gm_back: 'ย้อนกลับ',
    gm_problem: 'ติดปัญหา',
    gm_contact_support: 'ติดต่อฝ่ายบริการลูกค้า',
    gm_warning: 'คำเตือน!',
    gm_min_max_deposit_prefix: 'เติมขั้นต่ำ',
    gm_min_max_deposit_mid: 'บาท สูงสุด',
    gm_confirm: 'ตกลง',
    gm_session_expired: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
    gm_not_eligible_promo: 'ท่านไม่เข้าเงื่อนใขโปรโมชั่นนี้',
    gm_used_today: 'ท่านใช้สิทธวันนี้ครบแล้ว',
    gm_already_used_promo: 'ท่านใช้โปรมั่นชั่นนี้ไปแล้ว',
    gm_pending_promo: 'ท่านใช้โปรโมชั่นค้างไว้ สามารถเติมเงินได้เลย',
    gm_announcement: 'ประกาศ',
    gm_hide_today: 'ไม่แสดงอีกวันนี้',
    gm_win_rate: 'อัตราชนะ',
    gm_game_problem: 'ขณะนี้เกมมีปัญหากรุณารอซักครู่',
    gm_wheel_title: 'กงล้อมหาสนุก',
    gm_wheel_desc: 'เติม 500 ได้สิทธิ์หมุนฟรี 1 สิทธิ์',
    gm_spin: 'หมุน',
    gm_not_login: ' คุณไม่ได้ทำการ Login',
  },
  en: {
    gm_btn_play: 'Play',
    gm_marquee: 'Online casino and online slots, fun in every way',
    gm_subheading: 'A full online casino, exciting with every bet',
    gm_h1_casino: 'Online casino, baccarat, Hi-Lo, Dragon Tiger, direct website',
    gm_promotion: 'Promotion',
    gm_pro_not_active: 'This promotion is not active yet',
    gm_get_promotion: 'Get promotion',
    gm_back: 'Back',
    gm_problem: 'Having trouble',
    gm_contact_support: 'Contact customer service',
    gm_warning: 'Warning!',
    gm_min_max_deposit_prefix: 'Minimum deposit',
    gm_min_max_deposit_mid: 'baht, maximum',
    gm_confirm: 'OK',
    gm_session_expired: 'Your session has expired. Please log in again.',
    gm_not_eligible_promo: 'You are not eligible for this promotion',
    gm_used_today: 'You have used all your rights for today',
    gm_already_used_promo: 'You have already used this promotion',
    gm_pending_promo: 'You have a pending promotion. You can top up now.',
    gm_announcement: 'Announcement',
    gm_hide_today: 'Do not show again today',
    gm_win_rate: 'Win rate',
    gm_game_problem: 'The game currently has an issue, please wait a moment',
    gm_wheel_title: 'Wheel of Fun',
    gm_wheel_desc: 'Top up 500 to get 1 free spin',
    gm_spin: 'Spin',
    gm_not_login: ' You are not logged in',
  },
  zh: {
    gm_btn_play: '进入游戏',
    gm_marquee: '在线赌场、在线老虎机，让您尽享各种乐趣',
    gm_subheading: '全面的在线赌场，每一次下注都令人兴奋',
    gm_h1_casino: '在线赌场、百家乐、骰宝、龙虎、官方直营网站',
    gm_promotion: '优惠活动',
    gm_pro_not_active: '此优惠活动尚未开启',
    gm_get_promotion: '领取优惠',
    gm_back: '返回',
    gm_problem: '遇到问题',
    gm_contact_support: '联系客服',
    gm_warning: '警告！',
    gm_min_max_deposit_prefix: '最低充值',
    gm_min_max_deposit_mid: '泰铢，最高',
    gm_confirm: '确定',
    gm_session_expired: '您的会话已过期，请重新登录。',
    gm_not_eligible_promo: '您不符合此优惠活动的条件',
    gm_used_today: '您今日的次数已用完',
    gm_already_used_promo: '您已使用过此优惠活动',
    gm_pending_promo: '您有一个待处理的优惠活动，现在可以充值。',
    gm_announcement: '公告',
    gm_hide_today: '今日不再显示',
    gm_win_rate: '胜率',
    gm_game_problem: '游戏目前出现问题，请稍候',
    gm_wheel_title: '欢乐大转盘',
    gm_wheel_desc: '充值500即可获得1次免费转动',
    gm_spin: '转动',
    gm_not_login: ' 您尚未登录',
  },
  ja: {
    gm_btn_play: 'プレイ',
    gm_marquee: 'オンラインカジノ・オンラインスロット、あらゆる楽しみ方ができます',
    gm_subheading: '本格的なオンラインカジノ、すべてのベットでわくわく',
    gm_h1_casino: 'オンラインカジノ、バカラ、ハイロー、ドラゴンタイガー、公式直営サイト',
    gm_promotion: 'プロモーション',
    gm_pro_not_active: 'このプロモーションはまだ有効ではありません',
    gm_get_promotion: 'プロモーションを受け取る',
    gm_back: '戻る',
    gm_problem: 'お困りですか',
    gm_contact_support: 'カスタマーサービスに連絡',
    gm_warning: '警告！',
    gm_min_max_deposit_prefix: '最低入金',
    gm_min_max_deposit_mid: 'バーツ、最大',
    gm_confirm: 'OK',
    gm_session_expired: 'セッションの有効期限が切れました。もう一度ログインしてください。',
    gm_not_eligible_promo: 'このプロモーションの対象ではありません',
    gm_used_today: '本日の利用回数を使い切りました',
    gm_already_used_promo: 'このプロモーションはすでに利用済みです',
    gm_pending_promo: '保留中のプロモーションがあります。今すぐ入金できます。',
    gm_announcement: 'お知らせ',
    gm_hide_today: '本日は再表示しない',
    gm_win_rate: '勝率',
    gm_game_problem: '現在ゲームに問題が発生しています。しばらくお待ちください',
    gm_wheel_title: 'ワクワクルーレット',
    gm_wheel_desc: '500入金で無料スピン1回獲得',
    gm_spin: '回す',
    gm_not_login: ' ログインしていません',
  },
  my: {
    gm_btn_play: 'ဆော့မည်',
    gm_marquee: 'အွန်လိုင်းကာစီနိုနှင့် အွန်လိုင်းစလော့၊ နည်းလမ်းစုံဖြင့် ပျော်ရွှင်နိုင်ပါသည်',
    gm_subheading: 'ပြည့်စုံသော အွန်လိုင်းကာစီနို၊ လောင်းကြေးတိုင်းတွင် စိတ်လှုပ်ရှားဖွယ်ကောင်းသည်',
    gm_h1_casino: 'အွန်လိုင်းကာစီနို၊ ဘတ်ကာရာ၊ Hi-Lo၊ Dragon Tiger၊ တိုက်ရိုက်ဝက်ဘ်ဆိုက်',
    gm_promotion: 'ပရိုမိုးရှင်း',
    gm_pro_not_active: 'ဤပရိုမိုးရှင်းကို မဖွင့်ရသေးပါ',
    gm_get_promotion: 'ပရိုမိုးရှင်းရယူမည်',
    gm_back: 'နောက်သို့',
    gm_problem: 'ပြဿနာရှိနေပါသလား',
    gm_contact_support: 'ဖောက်သည်ဝန်ဆောင်မှုကို ဆက်သွယ်ပါ',
    gm_warning: 'သတိပေးချက်！',
    gm_min_max_deposit_prefix: 'အနည်းဆုံးငွေသွင်း',
    gm_min_max_deposit_mid: 'ဘတ်၊ အများဆုံး',
    gm_confirm: 'အိုကေ',
    gm_session_expired: 'သင်၏ Session သက်တမ်းကုန်သွားပါပြီ။ ထပ်မံ login ဝင်ပါ။',
    gm_not_eligible_promo: 'ဤပရိုမိုးရှင်းအတွက် သင်အရည်အချင်းမပြည့်မီပါ',
    gm_used_today: 'ယနေ့အတွက် သင်၏အခွင့်အရေးများ ကုန်သွားပါပြီ',
    gm_already_used_promo: 'ဤပရိုမိုးရှင်းကို သင်အသုံးပြုပြီးဖြစ်ပါသည်',
    gm_pending_promo: 'ဆိုင်းငံ့ထားသော ပရိုမိုးရှင်းရှိနေပါသည်။ ယခုငွေဖြည့်နိုင်ပါသည်။',
    gm_announcement: 'ကြေညာချက်',
    gm_hide_today: 'ယနေ့ထပ်မပြပါနှင့်',
    gm_win_rate: 'အနိုင်ရနှုန်း',
    gm_game_problem: 'ဂိမ်းတွင် လက်ရှိပြဿနာရှိနေပါသည်၊ ခဏစောင့်ပါ',
    gm_wheel_title: 'ပျော်ရွှင်ဖွယ်ဘီးလည်',
    gm_wheel_desc: '500 ဖြည့်ပါက အခမဲ့လှည့်ခွင့် 1 ကြိမ်ရမည်',
    gm_spin: 'လှည့်မည်',
    gm_not_login: ' သင် Login ဝင်ထားခြင်းမရှိပါ',
  },
  lo: {
    gm_btn_play: 'ເຂົ້າຫຼິ້ນ',
    gm_marquee: 'ຄາສິໂນອອນລາຍ ສະລັອດອອນລາຍ ທີ່ໃຫ້ທ່ານມ່ວນຊື່ນໄດ້ທຸກຮູບແບບ',
    gm_subheading: 'ຄາສິໂນອອນລາຍເຕັມຮູບແບບ ຕື່ນຕາຕື່ນໃຈໄປກັບທຸກການເດີມພັນ',
    gm_h1_casino: 'ຄາສິໂນອອນລາຍ ບາກາຣາ ໄຮໂລ ເສືອມັງກອນ ເວັບກົງ',
    gm_promotion: 'ໂປຣໂມຊັ່ນ',
    gm_pro_not_active: 'ໂປຣໂມຊັ່ນນີ້ຍັງບໍ່ໄດ້ເປີດໃຊ້ງານ',
    gm_get_promotion: 'ຮັບໂປຣໂມຊັ່ນ',
    gm_back: 'ກັບຄືນ',
    gm_problem: 'ຕິດບັນຫາ',
    gm_contact_support: 'ຕິດຕໍ່ຝ່າຍບໍລິການລູກຄ້າ',
    gm_warning: 'ຄຳເຕືອນ!',
    gm_min_max_deposit_prefix: 'ເຕີມຂັ້ນຕ່ຳ',
    gm_min_max_deposit_mid: 'ບາດ ສູງສຸດ',
    gm_confirm: 'ຕົກລົງ',
    gm_session_expired: 'Session ຂອງທ່ານໝົດອາຍຸ ກະລຸນາ login ເຂົ້າສູ່ລະບົບອີກຄັ້ງ',
    gm_not_eligible_promo: 'ທ່ານບໍ່ເຂົ້າເງື່ອນໄຂໂປຣໂມຊັ່ນນີ້',
    gm_used_today: 'ທ່ານໃຊ້ສິດມື້ນີ້ຄົບແລ້ວ',
    gm_already_used_promo: 'ທ່ານໃຊ້ໂປຣໂມຊັ່ນນີ້ໄປແລ້ວ',
    gm_pending_promo: 'ທ່ານໃຊ້ໂປຣໂມຊັ່ນຄ້າງໄວ້ ສາມາດເຕີມເງິນໄດ້ເລີຍ',
    gm_announcement: 'ປະກາດ',
    gm_hide_today: 'ບໍ່ສະແດງອີກມື້ນີ້',
    gm_win_rate: 'ອັດຕາຊະນະ',
    gm_game_problem: 'ຕອນນີ້ເກມມີບັນຫາ ກະລຸນາລໍຖ້າຄາວໜຶ່ງ',
    gm_wheel_title: 'ກົງລໍ້ມະຫາສະໜຸກ',
    gm_wheel_desc: 'ເຕີມ 500 ໄດ້ສິດໝຸນຟຣີ 1 ສິດ',
    gm_spin: 'ໝຸນ',
    gm_not_login: ' ທ່ານຍັງບໍ່ໄດ້ Login',
  },
};

Object.keys(ext).forEach((l) => {
  translations[l] = Object.assign({}, translations[l], ext[l]);
});

export default ext;
